import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

/* WCAG 2.4.1 Bypass Blocks — a skip-to-main-content link that is
 * visually hidden until it receives keyboard focus. First tab stop
 * on every page. */

export default function SkipToContent() {
  const { t } = useLanguage();
  return (
    <a
      href="#main-content"
      className="tf-skip-link"
      data-testid="skip-to-main-content"
    >
      {t('skip.main')}
    </a>
  );
}
